import { KeyValue } from '@/main/models/common';

export enum RateImportStatusTypes {
  GET_RATE_IMPORT_STATUS = '@rateImportStatus/GET_RATE_IMPORT_STATUS',
  SAVE_RATE_IMPORT_STATUS = '@rateImportStatus/SAVE_RATE_IMPORT_STATUS',
  RESET_REDUCER_RATE_IMPORT_STATUS = '@rateImportStatus/RESET_REDUCER_RATE_IMPORT_STATUS'
}

export interface RateImportStatusState {
  readonly rateImportStatus: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetRateImportStatus {
  type: typeof RateImportStatusTypes.GET_RATE_IMPORT_STATUS;
}

export interface SaveRateImportStatus {
  type: typeof RateImportStatusTypes.SAVE_RATE_IMPORT_STATUS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerRateImportStatus {
  type: typeof RateImportStatusTypes.RESET_REDUCER_RATE_IMPORT_STATUS;
}

export type RateImportStatusActionTypes =
  | GetRateImportStatus
  | SaveRateImportStatus
  | ResetReducerRateImportStatus;
